import React from "react";
import { Sparkles as SparkIcon, Heart } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-20 pb-10 overflow-hidden"
      style={{ background: "linear-gradient(180deg,#08140B 0%, #050B07 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 relative">
        <div className="text-center mb-12">
          <SparkIcon className="text-amber-300 mx-auto mb-4" size={28} />
          <h3 className="font-heading text-3xl md:text-4xl text-white">
            Until we meet in the <span className="italic text-gradient-gold">glade</span>
          </h3>
          <p className="mt-3 text-emerald-50/65 max-w-md mx-auto">
            Carry a tiny piece of Miara Mountain with you, wherever the day takes you.
          </p>
        </div>

        <div className="border-t border-amber-500/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="font-accent text-amber-300/90 text-lg">
            sybellecheesman.com
          </div>
          <div className="text-sm text-emerald-50/55 flex items-center gap-1.5">
            © {year} Sybelle Cheesman · Crafted with{" "}
            <Heart size={12} className="text-amber-400 fill-amber-400" /> & pixie dust
          </div>
          <div className="flex items-center gap-4 text-xs text-emerald-50/50">
            <a href="#books" className="hover:text-amber-300 transition-colors">Books</a>
            <a href="#author" className="hover:text-amber-300 transition-colors">Author</a>
            <a href="#contact" className="hover:text-amber-300 transition-colors">Contact</a>
          </div>
        </div>

        <p className="mt-6 text-center text-[10px] text-emerald-50/30" data-testid="music-credit">
          Music: “Celtic Impulse” by Kevin MacLeod (incompetech.com) · Licensed under Creative Commons: By Attribution 4.0
        </p>
      </div>
    </footer>
  );
};

export default Footer;
